module.exports = __webpack_public_path__ + "static/media/eaciit-white-logo.8282943b.png";